import "../css/styles.scss";

import "./modules/OnLoad.js";
